import { Action } from 'redux-actions';
import { PapiModuleTiers } from '@wix/da-papi-types';
import { Gruser } from '@wix/da-gruser-shared/pkg/types/papi';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { updateModule } from '@wix/da-gruser-shared/pkg/redux/actions/modules';
import { putEntities } from '@wix/da-shared-react/pkg/redux/entities/actions';

export default (gruser: Gruser, moduleId: number, moduleData: PapiModuleTiers): Action<any>[] => {
  const extendedTiers = moduleData.extendedTiers || [];

  const tiersWithExtendedData = extendedTiers.map(extendedTier => {
    const { tier, eligibleDiscount, notEligibleDiscounts } = extendedTier;

    const extendedData = {
      saleDetails: {
        subscription: {
          eligibleDiscount,
          notEligibleDiscounts,
        },
      },
    };

    return {
      ...tier,
      extended: {
        ...tier.extended,
        ...extendedData,
      },
    };
  });

  const { result: tiersResult, entities: tiersEntities } = normalize(tiersWithExtendedData, [
    deviationSchema,
  ]);

  return [
    putEntities({ entities: tiersEntities }),
    updateModule(gruser, {
      id: moduleId,
      moduleData: {
        tiers: tiersResult,
      },
    }),
  ];
};
